const initialState = {
	allCategories: [],
	loading: false,
};
const categoryReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'ADD_CATEGORY_REQUEST':
			return {
				...state,
				loading: true,
			};
		case 'ADD_CATEGORY_SUCCESS':
			return {
				...state,
				loading: false,
			};
		case 'GET_ALL_CATEGORIES':
			return {
				...state,
				allCategories: action.payload,
			};

		case 'UPDATE_CATEGORY':
			return {
				...state,
			};
		case 'DELETE_CATEGORY':
			return {
				...state,
			};

		default:
			return state;
	}
};

export default categoryReducer;
